module.exports = __webpack_public_path__ + "img/home.56be0723.svg";